import n from "highlight.js/lib/languages/javascript";
import r from "highlight.js/lib/languages/typescript";
import t from "highlight.js/lib/languages/csharp";
import e from "highlight.js/lib/languages/c-like";
import i from "highlight.js/lib/languages/go";
import o from "highlight.js/lib/languages/http";
import a from "highlight.js/lib/languages/ini";
import l from "highlight.js/lib/languages/java";
import u from "highlight.js/lib/languages/perl";
import c from "highlight.js/lib/languages/php";
import g from "highlight.js/lib/languages/python";
import h from "highlight.js/lib/languages/ruby";
import s from "highlight.js/lib/languages/rust";
import d from "highlight.js/lib/languages/scala";
import f from "highlight.js/lib/languages/swift";
import p from "highlight.js/lib/languages/kotlin";
import m from "highlight.js/lib/languages/objectivec";
import b from "highlight.js/lib/languages/bash";
import v from "highlight.js/lib/languages/shell";
import y from "highlight.js/lib/languages/sql";
import k from "highlight.js/lib/languages/yaml";
import x from "highlight.js/lib/languages/json";
import w from "highlight.js/lib/languages/diff";
import j from "highlight.js/lib/languages/xml";
import { injectGlobal as N, css as O, cx as C } from "@leafygreen-ui/emotion";
import { uiColors as S } from "@leafygreen-ui/palette";
import L, { createContext as M, useContext as A, useMemo as E, useState as D, useEffect as P, useRef as T } from "react";
import F from "prop-types";
import q from "clipboard";
import I from "lodash/debounce";
import { usePrevious as W, useIsomorphicLayoutEffect as B } from "@leafygreen-ui/hooks";
import { spacing as R, fontFamilies as _ } from "@leafygreen-ui/tokens";
import { useUsingKeyboardContext as z } from "@leafygreen-ui/leafygreen-provider";
import J from "highlight.js/lib/core";
import G from "highlightjs-graphql";
import { transparentize as K, darken as H } from "polished";
import { jsx as U } from "@emotion/react";
import { VisuallyHidden as X } from "@leafygreen-ui/a11y";
import Y from "@leafygreen-ui/icon/dist/Checkmark";
import $ from "@leafygreen-ui/icon/dist/Copy";
import Q from "@leafygreen-ui/icon-button";
import { isComponentType as V } from "@leafygreen-ui/lib";
import { isComponentGlyph as Z } from "@leafygreen-ui/icon";
import nn from "@leafygreen-ui/button";
import { Select as rn, Option as tn } from "@leafygreen-ui/select";
function en(n) {
  return (en = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (n) {
    return typeof n;
  } : function (n) {
    return n && "function" == typeof Symbol && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
  })(n);
}
function on(n, r, t) {
  return r in n ? Object.defineProperty(n, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : n[r] = t, n;
}
function an() {
  return (an = Object.assign || function (n) {
    for (var r = 1; r < arguments.length; r++) {
      var t = arguments[r];
      for (var e in t) Object.prototype.hasOwnProperty.call(t, e) && (n[e] = t[e]);
    }
    return n;
  }).apply(this, arguments);
}
function ln(n, r) {
  var t = Object.keys(n);
  if (Object.getOwnPropertySymbols) {
    var e = Object.getOwnPropertySymbols(n);
    r && (e = e.filter(function (r) {
      return Object.getOwnPropertyDescriptor(n, r).enumerable;
    })), t.push.apply(t, e);
  }
  return t;
}
function un(n, r) {
  if (null == n) return {};
  var t,
    e,
    i = function (n, r) {
      if (null == n) return {};
      var t,
        e,
        i = {},
        o = Object.keys(n);
      for (e = 0; e < o.length; e++) t = o[e], r.indexOf(t) >= 0 || (i[t] = n[t]);
      return i;
    }(n, r);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(n);
    for (e = 0; e < o.length; e++) t = o[e], r.indexOf(t) >= 0 || Object.prototype.propertyIsEnumerable.call(n, t) && (i[t] = n[t]);
  }
  return i;
}
function cn(n, r) {
  return r || (r = n.slice(0)), Object.freeze(Object.defineProperties(n, {
    raw: {
      value: Object.freeze(r)
    }
  }));
}
function gn(n, r) {
  return function (n) {
    if (Array.isArray(n)) return n;
  }(n) || function (n, r) {
    if ("undefined" == typeof Symbol || !(Symbol.iterator in Object(n))) return;
    var t = [],
      e = !0,
      i = !1,
      o = void 0;
    try {
      for (var a, l = n[Symbol.iterator](); !(e = (a = l.next()).done) && (t.push(a.value), !r || t.length !== r); e = !0);
    } catch (n) {
      i = !0, o = n;
    } finally {
      try {
        e || null == l.return || l.return();
      } finally {
        if (i) throw o;
      }
    }
    return t;
  }(n, r) || sn(n, r) || function () {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }();
}
function hn(n) {
  return function (n) {
    if (Array.isArray(n)) return dn(n);
  }(n) || function (n) {
    if ("undefined" != typeof Symbol && Symbol.iterator in Object(n)) return Array.from(n);
  }(n) || sn(n) || function () {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }();
}
function sn(n, r) {
  if (n) {
    if ("string" == typeof n) return dn(n, r);
    var t = Object.prototype.toString.call(n).slice(8, -1);
    return "Object" === t && n.constructor && (t = n.constructor.name), "Map" === t || "Set" === t ? Array.from(n) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? dn(n, r) : void 0;
  }
}
function dn(n, r) {
  (null == r || r > n.length) && (r = n.length);
  for (var t = 0, e = new Array(r); t < r; t++) e[t] = n[t];
  return e;
}
var fn,
  pn = {
    javascript: n,
    typescript: r,
    csharp: t,
    clike: e,
    go: i,
    http: o,
    ini: a,
    java: l,
    perl: u,
    php: c,
    python: g,
    ruby: h,
    rust: s,
    scala: d,
    swift: f,
    kotlin: p,
    objectivec: m,
    bash: b,
    shell: v,
    sql: y,
    yaml: k,
    json: x,
    diff: w,
    xml: j
  },
  mn = {
    JavaScript: "javascript",
    JS: "js",
    TypeScript: "typescript",
    TS: "ts",
    Csharp: "csharp",
    Cs: "cs",
    CLike: "clike",
    Go: "go",
    Http: "http",
    Ini: "ini",
    Java: "java",
    Perl: "perl",
    Php: "php",
    Python: "python",
    Ruby: "ruby",
    Rust: "rust",
    Scala: "scala",
    Swift: "swift",
    Kotlin: "kotlin",
    ObjectiveC: "objectivec",
    Bash: "bash",
    Shell: "shell",
    Sql: "sql",
    Yaml: "yaml",
    Json: "json",
    Graphql: "graphql",
    Diff: "diff",
    Xml: "xml"
  },
  bn = {
    Light: "light",
    Dark: "dark"
  },
  vn = function (n) {
    for (var r = 1; r < arguments.length; r++) {
      var t = null != arguments[r] ? arguments[r] : {};
      r % 2 ? ln(Object(t), !0).forEach(function (r) {
        on(n, r, t[r]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(n, Object.getOwnPropertyDescriptors(t)) : ln(Object(t)).forEach(function (r) {
        Object.defineProperty(n, r, Object.getOwnPropertyDescriptor(t, r));
      });
    }
    return n;
  }({}, mn, {
    None: "none"
  }),
  yn = (on(fn = {}, bn.Light, {
    0: S.gray.light3,
    1: S.gray.light2,
    2: S.gray.dark1,
    3: S.black,
    4: S.white,
    5: "#D83713",
    6: "#EDB210",
    7: "#12824D",
    8: "#016EE9",
    9: "#016EE9",
    10: "#CC3887"
  }), on(fn, bn.Dark, {
    0: S.black,
    1: S.gray.dark3,
    2: "#919DA1",
    3: S.gray.light3,
    4: S.gray.dark2,
    5: "#FF6F44",
    6: "#EDB210",
    7: "#35DE7B",
    8: "#a5e3ff",
    9: "#2DC4FF",
    10: "#FF7DC3"
  }), fn);
function kn() {
  Object.values(bn).forEach(function (n) {
    return N(function (n) {
      return "\n  .lg-highlight-hljs-".concat(n, " {\n    .lg-highlight-quote,\n    .lg-highlight-literal,\n    .lg-highlight-class,\n    .lg-highlight-section,\n    .lg-highlight-name,\n    .lg-highlight-number,\n    .lg-highlight-class.lg-highlight-keyword,\n    .lg-highlight-function.lg-highlight-keyword {\n      color: ").concat(yn[n][9], ";\n    }\n\n    .lg-highlight-function.lg-highlight-params {\n      color: ").concat(yn[n][5], "\n    }\n\n    .lg-highlight-function.lg-highlight-keyword,\n    .lg-highlight-function.lg-highlight-built_in {\n      color: ").concat(yn[n][9], ";\n    }\n  \n    .lg-highlight-regexp,\n    .lg-highlight-params,\n    .lg-highlight-meta,\n    .lg-highlight-meta-string {\n      color: ").concat(yn[n][8], ";\n    }\n  \n    .lg-highlight-comment {\n      color: ").concat(yn[n][2], ";\n      font-style: italic;\n    }\n\n    .lg-highlight-doctag,\n    .lg-highlight-formula {\n      color: ").concat(yn[n][3], ";\n    }\n  \n    .lg-highlight-keyword,\n    .lg-highlight-selector-tag,\n    .lg-highlight-selector-attr,\n    .lg-highlight-selector-pseudo,\n    .lg-highlight-selector-id,\n    .lg-highlight-selector-class {\n      color: ").concat(yn[n][10], ";\n    }\n  \n    .lg-highlight-variable,\n    .lg-highlight-deletion,\n    .lg-highlight-symbol,\n    .lg-highlight-bullet,\n    .lg-highlight-subst,\n    .lg-highlight-meta,\n    .lg-highlight-link,\n    .lg-highlight-attr,\n    .lg-highlight-attribute,\n    .lg-highlight-built_in,\n    .lg-highlight-template-variable,\n    .lg-highlight-type {\n      color: ").concat(yn[n][5], "\n    }\n  \n    .lg-highlight-string {\n      font-weight: 600;\n    }\n    .lg-highlight-string,\n    .lg-highlight-addition,\n    .lg-highlight-title {\n      color: ").concat(yn[n][7], ";\n    }\n  \n    .lg-highlight-emphasis {\n      font-style: italic;\n    }\n  \n    .lg-highlight-strong {\n      font-weight: bold;\n    }\n  }\n");
    }(n));
  });
}
var xn = M({
  highlightLines: [],
  darkMode: !1
});
function wn() {
  var n = cn(["\n              display: inline-block;\n            "]);
  return wn = function () {
    return n;
  }, n;
}
function jn() {
  var n = cn(["\n              user-select: none;\n              text-align: right;\n              padding-left: ", "px;\n              padding-right: 0;\n              color: ", ";\n            "]);
  return jn = function () {
    return n;
  }, n;
}
function Nn() {
  var n = cn(["\n    background-color: ", ";\n    background-image: ", ";\n    // Fixes an issue in Safari where the gradient applied to the table row would be applied\n    // to each cell in the row instead of being continuous across cells.\n    background-attachment: fixed;\n\n    // Selects all children of a highlighted row, and adds a border top\n    & > td {\n      border-top: 1px solid ", ";\n    }\n\n    // Selects following rows after a highlighted row, and adds a border top\n    // We don't add border bottoms here to support consecutive highlighted rows.\n    & + tr > td {\n      border-top: 1px solid ", ";\n    }\n\n    // Remove borders between consecutive highlighted rows\n    & + & > td {\n      border-top: 0;\n    }\n\n    // If the highlighted row is the last child, then we add a border bottom\n    &:last-child > td {\n      border-bottom: 1px solid ", ";\n    }\n  "]);
  return Nn = function () {
    return n;
  }, n;
}
function On() {
  var n = cn(["\n  border-spacing: 0;\n  vertical-align: top;\n  padding: 0 ", "px;\n"]);
  return On = function () {
    return n;
  }, n;
}
function Cn() {
  for (var n = arguments.length, r = new Array(n), t = 0; t < n; t++) r[t] = arguments[t];
  return r.filter(function (n) {
    return An(n) && n.length > 0;
  }).map(function (n) {
    var r = "lg-highlight-";
    return n.startsWith(r) ? n : "".concat(r).concat(n);
  }).join(" ");
}
function Sn(n) {
  var r = n.kind,
    t = n.children;
  return U("span", {
    className: r
  }, t);
}
function Ln(n) {
  return null != n && n instanceof Array;
}
function Mn(n) {
  return null != n && "object" === en(n) && !(n instanceof Array);
}
function An(n) {
  return null != n && "string" == typeof n;
}
function En(n) {
  return null != n && "object" === en(n) && "string" == typeof n.kind && n.children instanceof Array;
}
function Dn(n, r) {
  return null == n ? null : An(n) ? n : Ln(n) ? n.map(Dn) : Mn(n) ? U(Sn, {
    key: r,
    kind: n.kind
  }, Dn(n.children)) : n;
}
var Pn = O(On(), R[3]);
function Tn(n) {
  var r, t, e;
  return n ? (r = "transparent", t = "linear-gradient(90deg, ".concat(S.gray.dark3, ", ").concat(K(100, S.gray.dark3), ")"), e = S.gray.dark3) : (r = S.yellow.light3, t = "none", e = S.yellow.light2), O(Nn(), r, t, e, e, e);
}
function Fn(n) {
  var r = n.lineNumber,
    t = n.highlighted,
    e = n.darkMode,
    i = n.children,
    o = S.gray[e ? "dark1" : "light1"],
    a = e ? S.gray.light2 : S.yellow.dark2;
  return U("tr", {
    className: C(on({}, Tn(e), t))
  }, r && U("td", {
    className: C(Pn, O(jn(), R[2], t ? a : o))
  }, r), U("td", {
    className: Pn
  }, i));
}
function qn(n, r) {
  return "string" == typeof n ? n : En(n) ? qn(n.children, r) : n.reduce(function (n, t) {
    var e, i;
    if (An(t)) {
      var o = r ? {
        kind: Cn(r),
        children: [t]
      } : t;
      return [].concat(hn(n), [o]);
    }
    return (null !== (e = null == t || null === (i = t.children) || void 0 === i ? void 0 : i.length) && void 0 !== e ? e : 0) > 1 ? [].concat(hn(n), hn(qn(t.children, Cn(r, t.kind)))) : function (n) {
      var r = (null != n ? n : {}).children;
      return !(!Ln(r) || 1 !== r.length || !An(r[0]));
    }(t) ? [].concat(hn(n), [{
      kind: Cn(r, t.kind),
      children: t.children
    }]) : En(t) ? [].concat(hn(n), hn(qn(t))) : n;
  }, []);
}
function In(n) {
  return Ln(n) ? n.some(In) : An(n) ? n.includes("\n") : !!Mn(n) && ((null === (r = n.children) || void 0 === r ? void 0 : r.includes("\n")) || An(null === (t = n.children) || void 0 === t ? void 0 : t[0]) && n.children[0].includes("\n"));
  var r, t;
}
function Wn(n) {
  var r = [],
    t = 0;
  null == r[t] && (r[t] = []);
  var e = function () {
    t++, r[t] = [];
  };
  return qn(n).forEach(function (n) {
    In(n) ? An(n) ? n.split("\n").forEach(function (n, i) {
      i > 0 && e(), n && r[t].push(n);
    }) : n.children[0].split("\n").forEach(function (i, o) {
      o > 0 && e(), r[t].push({
        kind: n.kind,
        children: [i]
      });
    }) : r[t].push(n);
  }), r;
}
function Bn(n) {
  for (var r = n.lines, t = A(xn), e = t.highlightLines, i = t.showLineNumbers, o = t.darkMode, a = hn(r); 0 === (null === (l = a[0]) || void 0 === l ? void 0 : l.length);) {
    var l;
    a.shift();
  }
  for (; 0 === (null === (u = a[a.length - 1]) || void 0 === u ? void 0 : u.length);) {
    var u;
    a.pop();
  }
  return U(L.Fragment, null, a.map(function (n, r) {
    var t,
      a = r + 1,
      l = function (n) {
        return e.some(function (r) {
          if (null != (t = r) && "number" == typeof t) return n === r;
          var t;
          if (Ln(r)) {
            var e = hn(r).sort(function (n, r) {
              return n - r;
            });
            return n >= e[0] && n <= e[1];
          }
          return !1;
        });
      }(a);
    i && (t = a);
    var u = (null == n ? void 0 : n.length) ? n.map(Dn) : U("div", {
      className: O(wn())
    });
    return U(Fn, {
      key: a,
      lineNumber: t,
      darkMode: o,
      highlighted: l
    }, u);
  }));
}
var Rn = {
  "after:highlight": function (n) {
    var r = n.emitter.rootNode;
    n.react = U(Bn, {
      lines: Wn(r.children)
    });
  }
};
function _n() {
  var n = cn(["\n            border-spacing: 0;\n            width: 100%;\n          "]);
  return _n = function () {
    return n;
  }, n;
}
function zn() {
  var n = cn(["\n  color: inherit;\n  font-size: 13px;\n  font-family: ", ";\n  line-height: 24px;\n"]);
  return zn = function () {
    return n;
  }, n;
}
function Jn(n) {
  return "cs" !== n && "js" !== n && "ts" !== n;
}
var Gn = !1;
var Kn = O(zn(), _.code);
function Hn(n) {
  var r = n.children,
    t = n.language,
    e = n.darkMode,
    i = void 0 !== e && e,
    o = n.showLineNumbers,
    a = void 0 !== o && o,
    l = n.highlightLines,
    u = void 0 === l ? [] : l,
    c = n.className,
    g = un(n, ["children", "language", "darkMode", "showLineNumbers", "highlightLines", "className"]);
  Gn || function () {
    Gn = !0, kn();
    var n = Object.values(mn).filter(Jn);
    n.forEach(function (n) {
      "graphql" === n ? G(J) : J.registerLanguage(n, pn[n]);
    }), J.configure({
      languages: n,
      classPrefix: "lg-highlight-",
      tabReplace: "  "
    }), J.addPlugin(Rn);
  }();
  var h = E(function () {
      return t === vn.None ? null : J.highlight(t, r, !0);
    }, [t, r]),
    s = null === h ? U(Bn, {
      lines: r.split("\n").map(function (n) {
        return n ? [n] : [];
      })
    }) : h.react,
    d = i ? bn.Dark : bn.Light;
  return U(xn.Provider, {
    value: {
      highlightLines: u,
      showLineNumbers: a,
      darkMode: i
    }
  }, U("code", an({}, g, {
    className: C("lg-highlight-hljs-".concat(d), Kn, t, c)
  }), U("table", {
    className: O(_n())
  }, U("tbody", null, s))));
}
function Un() {
  var n = cn(["\n        background-color: ", ";\n        color: ", ";\n      "]);
  return Un = function () {
    return n;
  }, n;
}
function Xn() {
  var n = cn(["\n        background-color: ", ";\n      "]);
  return Xn = function () {
    return n;
  }, n;
}
function Yn() {
  var n = cn(["\n        color: ", ";\n        background-color: ", ";\n\n        &:focus {\n          color: ", ";\n\n          &:before {\n            background-color: ", ";\n          }\n        }\n\n        &:hover {\n          color: ", ";\n\n          &:before {\n            background-color: ", ";\n          }\n        }\n      "]);
  return Yn = function () {
    return n;
  }, n;
}
function $n() {
  var n = cn(["\n    align-self: center;\n    color: ", ";\n  "]);
  return $n = function () {
    return n;
  }, n;
}
function Qn(n, r, t) {
  var e,
    i = O($n(), S.gray.base);
  return r ? C(i, O(Yn(), S.white, S.green.base, S.white, S.green.base, S.white, S.green.base)) : n === bn.Dark ? C(i, (on(e = {}, O(Xn(), S.gray.dark3), !t), on(e, O(Un(), S.gray.dark2, S.gray.light2), t), e)) : i;
}
function Vn(n) {
  var r = n.onCopy,
    t = n.contents,
    e = n.darkMode,
    i = n.withLanguageSwitcher,
    o = void 0 !== i && i,
    a = gn(D(!1), 2),
    l = a[0],
    u = a[1],
    c = gn(D(null), 2),
    g = c[0],
    h = c[1],
    s = e ? bn.Dark : bn.Light;
  P(function () {
    if (g) {
      var n = new q(g, {
        text: function () {
          return t;
        }
      });
      if (l) {
        var r = setTimeout(function () {
          u(!1);
        }, 1500);
        return function () {
          return clearTimeout(r);
        };
      }
      return function () {
        return n.destroy();
      };
    }
  }, [g, t, l]);
  return U(Q, {
    ref: h,
    darkMode: e,
    "aria-label": "Copy",
    className: Qn(s, l, o),
    onClick: function (n) {
      n.preventDefault(), r && r(), u(!0);
    }
  }, U(l ? Y : $, null), l && U(X, {
    role: "alert"
  }, "Copied!"));
}
function Zn() {
  var n = cn(["\n      color: ", ";\n    "]);
  return Zn = function () {
    return n;
  }, n;
}
function nr() {
  var n = cn(["\n  margin-right: ", "px;\n"]);
  return nr = function () {
    return n;
  }, n;
}
function rr() {
  var n = cn(["\n  width: 144px;\n"]);
  return rr = function () {
    return n;
  }, n;
}
function tr() {
  var n = cn(["\n    &:focus {\n      background-color: ", ";\n    }\n  "]);
  return tr = function () {
    return n;
  }, n;
}
function er() {
  var n = cn(["\n    &:focus {\n      background-color: ", ";\n    }\n  "]);
  return er = function () {
    return n;
  }, n;
}
function ir() {
  var n = cn(["\n    border-right: 1px solid ", ";\n\n    &:hover,\n    &:focus,\n    &:active {\n      border-right: 1px solid ", ";\n    }\n\n    &:hover,\n    &:active {\n      background-color: ", ";\n    }\n  "]);
  return ir = function () {
    return n;
  }, n;
}
function or() {
  var n = cn(["\n    background-color: ", ";\n    border-right: 1px solid ", ";\n    box-shadow: 0 0 0 0;\n\n    &:hover,\n    &:active,\n    &:focus {\n      border-right: 1px solid ", ";\n    }\n\n    &:hover {\n      background-color: ", ";\n    }\n  "]);
  return or = function () {
    return n;
  }, n;
}
function ar() {
  var n = cn(["\n  border-radius: 4px 0px 0px 0px;\n  margin-left: -12px;\n  border: 0;\n\n  &:hover,\n  &:focus,\n  &:active {\n    box-shadow: 0 0 0 0;\n    border: 0;\n  }\n"]);
  return ar = function () {
    return n;
  }, n;
}
function lr() {
  var n = cn(["\n  display: flex;\n  align-items: center;\n  width: 100%;\n  margin-top: -2px;\n  margin-left: -1px;\n"]);
  return lr = function () {
    return n;
  }, n;
}
Hn.displayName = "Syntax", Hn.propTypes = {
  children: F.string.isRequired,
  language: F.oneOf(Object.values(vn)),
  className: F.string,
  darkMode: F.bool,
  showLineNumbers: F.bool,
  highlightLines: F.arrayOf(F.oneOfType([F.arrayOf(F.number), F.number]))
}, Vn.displayName = "CopyButton";
var ur = O(lr()),
  cr = O(ar()),
  gr = {
    light: O(or(), S.white, S.gray.light2, S.gray.light2, S.gray.light2),
    dark: O(ir(), S.gray.dark3, S.gray.dark3, S.gray.dark1)
  },
  hr = {
    light: O(er(), S.blue.light2),
    dark: O(tr(), S.focus)
  },
  sr = O(rr()),
  dr = O(nr(), R[3]);
function fr(n) {
  var r,
    t = n.language,
    e = n.languageOptions,
    i = n.onChange,
    o = n.darkMode,
    a = z().usingKeyboard,
    l = o ? "dark" : "light",
    u = W(t),
    c = C(dr, O(Zn(), o ? S.white : S.gray.dark1)),
    g = U($, {
      className: c
    });
  return null != t.image && (r = t.image, g = Z(r) || V(r, "Icon") ? L.cloneElement(t.image, {
    className: c
  }) : L.cloneElement(t.image, {
    className: dr
  })), U("div", {
    className: ur
  }, U(rn, {
    darkMode: o,
    onChange: function (n) {
      if ("" === n && void 0 !== u) return i(u);
      var r = e.find(function (r) {
        return r.displayName === n;
      });
      void 0 !== r && i(r);
    },
    "aria-labelledby": "Language Picker",
    value: null == t ? void 0 : t.displayName,
    className: sr,
    allowDeselect: !1,
    __INTERNAL__menuButtonSlot__: L.forwardRef(function (n, r) {
      var t = n.className,
        e = n.children,
        i = un(n, ["className", "children"]);
      return U(nn, an({}, i, {
        className: C(t, cr, gr[l], on({}, hr[l], a)),
        darkMode: o,
        ref: r,
        leftGlyph: g
      }), e);
    })
  }, null == e ? void 0 : e.map(function (n) {
    return U(tn, {
      key: null == n ? void 0 : n.displayName,
      value: null == n ? void 0 : n.displayName
    }, null == n ? void 0 : n.displayName);
  })));
}
function pr() {
  var n = cn(["\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    padding-left: 12px;\n    padding-right: 8px;\n    background-color: ", ";\n    border-bottom: 1px solid ", ";\n  "]);
  return pr = function () {
    return n;
  }, n;
}
function mr() {
  var n = cn(["\n        border-color: ", ";\n        background-color: ", ";\n      "]);
  return mr = function () {
    return n;
  }, n;
}
function br() {
  var n = cn(["\n        border-color: ", ";\n        background-color: white;\n      "]);
  return br = function () {
    return n;
  }, n;
}
function vr() {
  var n = cn(["\n  min-height: ", "px;\n  padding-top: ", "px;\n"]);
  return vr = function () {
    return n;
  }, n;
}
function yr() {
  var n = cn(["\n  width: 38px;\n  border-left: solid 1px;\n  display: flex;\n  flex-direction: column;\n  flex-shrink: 0;\n  padding-top: 6px;\n"]);
  return yr = function () {
    return n;
  }, n;
}
fr.displayName = "LanguageSwitcher";
var kr = O(yr()),
  xr = O(vr(), 36, R[1]);
function wr(n, r, t) {
  if (!r) return C(kr, xr, on({}, xr, !t), function (n) {
    var r = yn[n];
    switch (n) {
      case bn.Light:
        return O(br(), r[1]);
      case bn.Dark:
        return O(mr(), r[1], r[1]);
    }
  }(n));
  var e = yn[n];
  return O(pr(), e[4], e[1]);
}
function jr(n) {
  var r = n.language,
    t = n.languageOptions,
    e = n.contents,
    i = n.onChange,
    o = n.onCopy,
    a = n.showCopyButton,
    l = n.darkMode,
    u = n.isMultiline;
  return U("div", {
    className: wr(l ? bn.Dark : bn.Light, !!r, void 0 !== u && u),
    "data-testid": "leafygreen-code-panel"
  }, void 0 !== r && void 0 !== t && void 0 !== i && U(fr, {
    onChange: i,
    language: r,
    languageOptions: t,
    darkMode: l
  }), a && U(Vn, {
    onCopy: o,
    darkMode: l,
    contents: e,
    withLanguageSwitcher: !!r
  }));
}
function Nr() {
  var n = cn(["\n          background-color: ", ";\n          color: ", ";\n        "]);
  return Nr = function () {
    return n;
  }, n;
}
function Or() {
  var n = cn(["\n        height: ", "px;\n        width: ", "px;\n        border-radius: 50px;\n        margin-right: 8px;\n        background-color: ", ";\n        border: 1px solid ", ";\n      "]);
  return Or = function () {
    return n;
  }, n;
}
function Cr() {
  var n = cn(["\n  padding-left: ", "px;\n  padding-right: ", "px;\n  font-size: 14px;\n"]);
  return Cr = function () {
    return n;
  }, n;
}
function Sr() {
  var n = cn(["\n  height: ", "px;\n  width: ", "px;\n"]);
  return Sr = function () {
    return n;
  }, n;
}
function Lr() {
  var n = cn(["\n  display: flex;\n  height: ", "px;\n"]);
  return Lr = function () {
    return n;
  }, n;
}
function Mr() {
  var n = cn(["\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  height: ", "px;\n  padding-left: ", "px;\n  padding-right: ", "px;\n  border-radius: ", "px ", "px 0 0;\n"]);
  return Mr = function () {
    return n;
  }, n;
}
jr.displayName = "Panel";
var Ar = "light",
  Er = "dark",
  Dr = O(Mr(), 28, 12, 12, 4, 4),
  Pr = O(Lr(), 12),
  Tr = O(Sr(), 12, 60),
  Fr = O(Cr(), 8, 8);
function qr(n) {
  var r = n.color;
  return U("div", {
    className: O(Or(), 12, 12, r, H(.03, r))
  });
}
function Ir(n) {
  var r = n.darkMode,
    t = void 0 !== r && r,
    e = n.chromeTitle,
    i = void 0 === e ? "" : e,
    o = yn[t ? Er : Ar];
  return U("div", {
    className: C(Dr, O(Nr(), o[1], o[2]))
  }, U("div", {
    className: Pr
  }, ["#FF5952", "#E7BF2A", "#54C22C"].map(function (n) {
    return U(qr, {
      key: n,
      color: n
    });
  })), U("div", {
    className: Fr
  }, i), U("div", {
    className: Tr
  }));
}
function Wr() {
  var n = cn(["\n            display: flex;\n          "]);
  return Wr = function () {
    return n;
  }, n;
}
function Br() {
  var n = cn(["\n    ", ";\n    border-radius: 4px;\n    overflow: hidden;\n  "]);
  return Br = function () {
    return n;
  }, n;
}
function Rr() {
  var n = cn(["\n      border: ", ";\n    "]);
  return Rr = function () {
    return n;
  }, n;
}
function _r() {
  var n = cn(["\n      box-shadow: inset -6px 0 6px -6px ", ";\n    "]);
  return _r = function () {
    return n;
  }, n;
}
function zr() {
  var n = cn(["\n      box-shadow: inset 6px 0 6px -6px ", ";\n    "]);
  return zr = function () {
    return n;
  }, n;
}
function Jr() {
  var n = cn(["\n      box-shadow: inset 6px 0 6px -6px ", ",\n        inset -6px 0 6px -6px ", ", inset 0 6px 6px -6px ", ",\n        inset 0 -6px 6px -6px ", ";\n    "]);
  return Jr = function () {
    return n;
  }, n;
}
function Gr() {
  var n = cn(["\n    ", ";\n    background-color: ", ";\n    color: ", ";\n  "]);
  return Gr = function () {
    return n;
  }, n;
}
function Kr() {
  var n = cn(["\n  display: flex;\n  flex-direction: column-reverse;\n  width: 700px;\n"]);
  return Kr = function () {
    return n;
  }, n;
}
function Hr() {
  var n = cn(["\n  &:focus {\n    outline: none;\n  }\n"]);
  return Hr = function () {
    return n;
  }, n;
}
function Ur() {
  var n = cn(["\n  display: flex;\n  align-items: center;\n  padding-top: ", "px;\n  padding-bottom: ", "px;\n"]);
  return Ur = function () {
    return n;
  }, n;
}
function Xr() {
  var n = cn(["\n  border-left: 0;\n"]);
  return Xr = function () {
    return n;
  }, n;
}
function Yr() {
  var n = cn(["\n  overflow-x: auto;\n  // Many applications have global styles that are adding a border and border radius to this element.\n  border-radius: 0;\n  border: 0;\n  // We apply left / right padding in Syntax to support line highlighting\n  padding-top: ", "px;\n  padding-bottom: ", "px;\n  margin: 0;\n  position: relative;\n  flex-grow: 1;\n\n  ", "\n"]);
  return Yr = function () {
    return n;
  }, n;
}
Ir.displayName = "WindowChrome", Ir.propTypes = {
  darkMode: F.bool,
  chromeTitle: F.string
};
var $r = function (n) {
    var r = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
      t = r.literal,
      e = r.overlap,
      i = t ? n : ["&"].concat(n);
    function o(n) {
      if ("object" != typeof n || null == n) return [];
      if (Array.isArray(n)) return n.map(o);
      var r = {},
        a = {},
        l = {};
      return Object.keys(n).forEach(function (u) {
        var c = n[u];
        if (!Array.isArray(c) && t && (c = [c]), (t || Array.isArray(c)) && 38 !== u.charCodeAt(0)) {
          var g = void 0;
          c.forEach(function (n, o) {
            if ((!e || g !== n) && null != n) if (g = n, 0 !== o || t) {
              if (void 0 === r[i[o]]) {
                var a;
                r[i[o]] = ((a = {})[u] = n, a);
              } else r[i[o]][u] = n;
            } else l[u] = n;
          });
        } else "object" == typeof c ? a[u] = o(c) : l[u] = c;
      }), i.forEach(function (n) {
        r[n] && (l[n] = r[n]);
      }), Object.assign(l, a), l;
    }
    return function () {
      for (var n = arguments.length, r = Array(n), t = 0; t < n; t++) r[t] = arguments[t];
      return r.map(o);
    };
  }(["@media only screen and (max-device-width: 812px) and (-webkit-min-device-pixel-ratio: 2)", "@media only screen and (min-device-width: 813px) and (-webkit-min-device-pixel-ratio: 2)"]),
  Qr = O(Yr(), R[2], R[2], $r({
    whiteSpace: ["pre", "pre-wrap", "pre"]
  })),
  Vr = O(Xr()),
  Zr = O(Ur(), 6, 6),
  nt = O(Hr()),
  rt = O(Kr());
var tt = "none",
  et = "left",
  it = "right",
  ot = "both";
function at(n) {
  var r = n.children,
    t = void 0 === r ? "" : r,
    e = n.className,
    i = n.language,
    o = n.darkMode,
    a = void 0 !== o && o,
    l = n.showLineNumbers,
    u = void 0 !== l && l,
    c = n.showWindowChrome,
    g = void 0 !== c && c,
    h = n.chromeTitle,
    s = void 0 === h ? "" : h,
    d = n.copyable,
    f = void 0 === d || d,
    p = n.onCopy,
    m = n.highlightLines,
    b = void 0 === m ? [] : m,
    v = n.languageOptions,
    y = n.onChange,
    k = un(n, ["children", "className", "language", "darkMode", "showLineNumbers", "showWindowChrome", "chromeTitle", "copyable", "onCopy", "highlightLines", "languageOptions", "onChange"]),
    x = T(null),
    w = z().usingKeyboard,
    j = gn(D(tt), 2),
    N = j[0],
    S = j[1],
    L = gn(D(!1), 2),
    M = L[0],
    A = L[1],
    F = a ? bn.Dark : bn.Light,
    W = E(function () {
      return t.trim().includes("\n");
    }, [t]),
    R = null == v ? void 0 : v.find(function (n) {
      return n.displayName === i;
    }),
    _ = R ? R.language : i;
  P(function () {
    A(f && q.isSupported());
  }, [f, g]), B(function () {
    var n = x.current;
    null != n && n.scrollWidth > n.clientWidth && S(it);
  }, []);
  var J = C(O(Rr(), R ? "1px solid;" : "2px solid;"), Qr, function (n) {
      var r = yn[n],
        t = "dark" === n ? "border: 0" : "border-color: ".concat(r[1]);
      return O(Gr(), t, r[0], r[3]);
    }(F), on({}, Vr, g), e, function (n, r) {
      var t = yn[r],
        e = r === bn.Light ? "rgba(93,108,116,0.3)" : "rgba(0,0,0,0.35)";
      return n === ot ? O(Jr(), e, e, t[0], t[0]) : n === et ? O(zr(), e) : n === it ? O(_r(), e) : "";
    }(N, F), on({}, Zr, !W), on({}, nt, !w)),
    G = U(Hn, {
      showLineNumbers: u,
      darkMode: a,
      language: _,
      highlightLines: b
    }, t);
  var K = I(function (n) {
      var r = n.target,
        t = r.scrollWidth,
        e = r.clientWidth;
      if (t > e) {
        var i = n.target.scrollLeft,
          o = t - e;
        i > 0 && i < o ? S(ot) : i > 0 ? S(et) : i < o && S(it);
      }
    }, 50, {
      leading: !0
    }),
    H = a ? "border: 0" : "border: 1px solid ".concat(yn[F][1]),
    X = O(Br(), H);
  return U("div", {
    className: X
  }, g && U(Ir, {
    chromeTitle: s,
    darkMode: a
  }), U("div", {
    className: C(O(Wr()), on({}, rt, !!R))
  }, U("pre", an({}, k, {
    className: J,
    onScroll: function (n) {
      n.persist(), K(n);
    },
    ref: x,
    tabIndex: N !== tt ? 0 : -1
  }), G), !g && (f || !!R) && U(jr, {
    language: R,
    languageOptions: v,
    onChange: y,
    contents: t,
    onCopy: p,
    showCopyButton: M,
    darkMode: a,
    isMultiline: W
  })));
}
at.displayName = "Code", at.propTypes = {
  children: F.string.isRequired,
  language: F.oneOfType([F.oneOf(Object.values(vn)), F.string]),
  darkMode: F.bool,
  className: F.string,
  showLineNumbers: F.bool,
  showWindowChrome: F.bool,
  chromeTitle: F.string,
  highlightLines: F.arrayOf(F.oneOfType([F.arrayOf(F.number), F.number]))
};
export default at;
export { vn as Language, bn as Mode, yn as variantColors };